import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { AlertDialogAction } from 'src/utils/alertDialog/alertDialog';
import { eventBus } from 'src/utils/eventBus';
import useStyles from './AlertDialog.styles';

const AlertDialog = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [confirmText, setConfirmText] = useState('OK');
  const [cancelText, setCancelText] = useState('Cancel');

  const promiseResolveRef = useRef<any>(null);

  const { classes } = useStyles();

  const handleClose = () => {
    setOpen(false);
    promiseResolveRef.current?.({
      isConfirmed: false,
    });
    promiseResolveRef.current = null;
  };

  const handleConfirm = () => {
    setOpen(false);
    if (promiseResolveRef.current) {
      promiseResolveRef.current({
        isConfirmed: true,
      });
      promiseResolveRef.current = null;
    }
  };

  const handleCancel = () => {
    setOpen(false);
    if (promiseResolveRef.current) {
      promiseResolveRef.current({
        isConfirmed: false,
      });
      promiseResolveRef.current = null;
    }
  };

  useEffect(() => {
    const handleFireEvent = (options: any, { resolve }: any) => {
      promiseResolveRef.current = resolve;
      setTitle(options.title || '');
      setDescription(options.description || '');
      setConfirmText(options.confirmText || 'OK');
      setCancelText(options.cancelText || 'Cancel');
      setOpen(true);
    };

    eventBus.on(AlertDialogAction.FIRE, handleFireEvent);
    return () => {
      eventBus.remove(AlertDialogAction.FIRE, handleFireEvent);
    };
  }, []);

  return (
    <Dialog open={open} maxWidth="xs" onClose={handleClose}>
      {title && <DialogTitle className={classes.title}>{title}</DialogTitle>}
      {description && (
        <DialogContent>
          <DialogContentText>{description}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={handleCancel} variant="outlined">
          {cancelText}
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="secondary" autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
